import React from 'react';
import { connect } from 'react-redux';
import { RootState } from 'reducers';
import { RouteComponentProps } from 'react-router-dom';
import { Table, Pagination, DatePicker, Button, Modal, Select, Tooltip } from 'components';
import { CleanIcon, AddIcon, EditIcon, DeleteIcon, Menu } from 'assets/icons';
import { Constants, Colors, Globals, checkPermission, Permissions } from 'utils';
import { BankService } from 'services';
import ModalCreate from './modal-create';
import UpdatePaymentMethod from './update-payment-method';

interface Props extends RootState, RouteComponentProps {
	dispatch: any
}

const TABS = {
	BANK_ACCOUNTS: 0
}

const INITIAL_STATE = {
	type: '',
	status: ''
}

class Banks extends React.Component<Props> {

	state = {
		data: [],
		page: 1,
		last_page: 1,
		header: [
			'Tipo de Cuenta',
			'Número de cuenta',
			'Banco',
			'Estatus',
			'Acción'
		],
		form: INITIAL_STATE,
		visible: false,
		item: null,
		banks: [],
		document_types: [],
		phonecodes: [],
		tab: TABS.BANK_ACCOUNTS,
		payment_methods: []
	}

	componentDidMount() {
		this.props.dispatch({
			type: 'SET_HEADER',
			payload: {
				title: 'Cuentas Bancarias',
				onBack: null
			}
		});

		this.props.dispatch({
			type: 'SET_SUBHEADER',
			payload: {
				title: ''
			}
		});

		this.loadData();
		this.load();
	}

	loadData = async () => {
		const res: any = await BankService.admin.getData({
			withoutLoading: true,
		});
		this.setState({
			phonecodes: res.phonecodes || [],
			document_types: res.document_types || [],
			banks: res.banks || [],
			payment_methods: res.payment_methods || []
		});
	}

	load = async (withoutLoading: boolean = false) => {
		const res: any = await BankService.admin.get({
			withoutLoading,
			page: this.state.page,
			...this.state.form,
		});
		this.setState({
			data: res.bank_accounts.rows,
			last_page: res.bank_accounts.count,
		});
	}

	reset = () => {
		this.setState({
			form: INITIAL_STATE,
			page: 1
		},() => this.load(true));
	}

	change = (e: any,callback = () => {}) => {
		this.setState({
			page: 1,
			form: {
				...this.state.form,
				[e.target.name]: e.target.value
			}
		},callback);
	}

	edit = (e: any, item: any) => {
		e.preventDefault();
		this.setState({
			visible: true,
			item
		});	
	}

	add = () => {
		this.setState({
			visible: true
		});	
	}

	getColor = (status: number) => {
		switch(status) {
			case Constants.BANK_ACCOUNT_STATUS.ACTIVE:
				return Colors.green;
			break;

			case Constants.BANK_ACCOUNT_STATUS.INACTIVE:
				return Colors.danger;
			break;
		}
	}

	delete = (e: any, item: any) => {
		e.preventDefault();
		Globals.confirm('¿Desea eliminar la cuenta bancaria?',async () => {
			await BankService.admin.delete({
				bank_account_id: item.id
			});
			this.load(true);
		});
	}

	onClose = () => {
		this.setState({
			visible: false,
			item: null
		},() => this.load(true));
	}

	changeStatus = (item: any) => {
		Globals.confirm(`¿Desea cambiar el estatus de la cuenta bancaria a ${ item.status == Constants.BANK_ACCOUNT_STATUS.ACTIVE ? 'Inactiva' : 'Activa' }?`,async () => {
			await BankService.admin.changeStatus({
				bank_account_id: item.id
			});
			this.load(true);
		});
	}

	setTab = (tab: number) => {
		this.setState({
			tab
		});
	}
	
	render() {
		const { visible } = this.state;

		return (
			<div id="admin-banks">
				<Modal
		          className="modal-create-bank-account"
		          visible={ visible }
		          withoutClose={ true }
		          onClose={ () => this.onClose() }
		        >
		          <ModalCreate
		          	item={ this.state.item }
		          	document_types={ this.state.document_types }
		          	phonecodes={ this.state.phonecodes }
		          	banks={ this.state.banks }
		            onClose={ () => this.onClose() } />
		      	</Modal>

		      	<div className="row row-tabs">
					<div className="col-md-3">
						<Button onClick={ () => this.setTab(TABS.BANK_ACCOUNTS) } className={ this.state.tab == TABS.BANK_ACCOUNTS ? 'active' : '' }>
							<img src={ Menu.Menu7 } />
							<div>
								Cuentas Bancarias
							</div>
						</Button>
					</div>
					{
						this.state.payment_methods.map((item: any) => {
							return (
								<div className="col-md-3">
									<Button onClick={ () => this.setTab(item.id) } className={ (this.state.tab == item.id ? 'active' : '') }>
										<img src={ Constants.BASE_PUBLIC + 'img/' + item.icon } />
										<div>
											{ item.name }
										</div>
									</Button>
								</div>
							)
						})
					}
				</div>

				{
					this.state.tab == TABS.BANK_ACCOUNTS && (
						<React.Fragment>
							<div className="row row-filter">
								<div className="col-md-4">
									<Select
										label="Tipo de Cuenta"
										name="type"
										onChange={ (e: any) => this.change(e,() => {
											this.load(true);
										}) }
										value={ this.state.form.type }
										options={ [
											{ value: Constants.BANK_ACCOUNT_TYPES.NATIONAL.toString(), label: 'Nacional' },
											{ value: Constants.BANK_ACCOUNT_TYPES.INTERNATIONAL.toString(), label: 'Internacional' }
										] } />
								</div>
								<div className="col-md-4">
									<Select
										label="Estatus de cuenta"
										name="status"
										onChange={ (e: any) => this.change(e,() => {
											this.load(true);
										}) }
										value={ this.state.form.status }
										options={ [
											{ value: Constants.BANK_ACCOUNT_STATUS.ACTIVE.toString(), label: 'Activas' },
											{ value: Constants.BANK_ACCOUNT_STATUS.INACTIVE.toString(), label: 'Inactivas' }
										] } />
								</div>
								<div className="col-md-2">
									{
										this.state.form != INITIAL_STATE && (
											<button className="btn btn-clean" onClick={ () => this.reset() }>
												<img src={ CleanIcon } />
											</button>
										)
									}
								</div>
							</div>

							<Table title="Historial de cuentas" data={ this.state.data.length } rightAlign={[ 4 ]} header={ this.state.header } titleRight={
								<React.Fragment>
									{
										checkPermission(Constants.MODULES.BANK_ACCOUNTS,'write',this.props.user) && (
											<Button className="btn-add" onClick={ () => this.add() }>
												<img src={ AddIcon } />
												Nuevo
											</Button>
										)
									}
								</React.Fragment>
							}>
								{ this.state.data.map((i: any,index: number) => {
									return (
										<tr key={ index }>
											<td>{ i.type_text }</td>
											<td>{ i.number }</td>
											<td>{ i.type == Constants.BANK_ACCOUNT_TYPES.NATIONAL ? i.bank?.name : i.bank_name }</td>
											<td className="status" style={{
												color: this.getColor(i.status)
											}} onClick={ () => {
												if (checkPermission(Constants.MODULES.BANK_ACCOUNTS,'write',this.props.user)) {
													this.changeStatus(i);
												}
											} }>{ i.status_text }</td>
											<td className="text-right">
												{
													checkPermission(Constants.MODULES.BANK_ACCOUNTS,'write',this.props.user) && (
														<Tooltip title="Editar">
															<a className="link-icon" href="#" onClick={ (e: any) => this.edit(e,i) }>
																<img src={ EditIcon } />
															</a>
														</Tooltip>
													)
												}
												{
													checkPermission(Constants.MODULES.BANK_ACCOUNTS,'delete',this.props.user) && (
														<Tooltip title="Eliminar">
															<a className="link-icon" href="#" onClick={ (e: any) => this.delete(e,i) }>
																<img src={ DeleteIcon } />
															</a>
														</Tooltip>
													)
												}
											</td>
										</tr>
									)
								}) }
							</Table>

							<Pagination 
								pages={ this.state.last_page } 
								active={ this.state.page }
								onChange={ async (page: number) => {
									await this.setState({
										page: page
									});
									this.load();
								} } />
						</React.Fragment>
					)
				}

				{
					this.state.tab == Constants.PAYMENT_METHODS.ZELLE && (
						// @ts-ignore
						<UpdatePaymentMethod 
							document_types={ this.state.document_types }
				          	phonecodes={ this.state.phonecodes }
				          	banks={ this.state.banks }
							payment_method_id={ Constants.PAYMENT_METHODS.ZELLE }
							history={ this.props.history }
							payment_methods={ this.state.payment_methods }
						/>
					)
				}

				{/* {
					this.state.tab == Constants.PAYMENT_METHODS.PAYPAL && (
						// @ts-ignore
						<UpdatePaymentMethod 
							document_types={ this.state.document_types }
				          	phonecodes={ this.state.phonecodes }
				          	banks={ this.state.banks }
							payment_method_id={ Constants.PAYMENT_METHODS.PAYPAL }
							history={ this.props.history }
							payment_methods={ this.state.payment_methods }
						/>
					)
				} */}

				{
					this.state.tab == Constants.PAYMENT_METHODS.MOVIL && (
						// @ts-ignore
						<UpdatePaymentMethod 
							document_types={ this.state.document_types }
				          	phonecodes={ this.state.phonecodes }
				          	banks={ this.state.banks }
							payment_method_id={ Constants.PAYMENT_METHODS.MOVIL }
							history={ this.props.history }
							payment_methods={ this.state.payment_methods }
						/>
					)
				}
			</div>
		)
	}
}

export default connect((state: RootState) => {
	return {
		user: state.user
	}
})(Banks);